import React, { createContext, useContext, useState, useEffect } from 'react';

const MarketContext = createContext();

const STORE_DATA_KEY = 'tef_markets_data';

export function MarketProvider({ children }) {
  const [currentMarket, setCurrentMarket] = useState(null);

  useEffect(() => {
    // Funktion zum Laden des aktuellen Markts aus dem localStorage
    const loadMarket = () => {
      try {
        const raw = localStorage.getItem(STORE_DATA_KEY);
        if (raw) {
          const data = JSON.parse(raw);
          if (data && data.stores && Array.isArray(data.stores)) {
            // Finde den Default Markt (isDefault === true)
            const defaultStore = data.stores.find(s => s.isDefault);
            if (defaultStore) {
              setCurrentMarket(defaultStore);
              return;
            }
          }
        }
        // Fallback, falls kein Markt als Standard markiert ist oder noch keiner gespeichert wurde
        setCurrentMarket({
          kette: 'Media Markt',
          stadt: 'Erfurt',
          standort: 'T.E.C.',
          adresse: 'Hermsdorfer Str. 4, 99099 Erfurt'
        });
      } catch (e) {
        console.error('[MarketProvider] Fehler beim Laden des Standardmarkts', e);
        setCurrentMarket({
          kette: 'Media Markt',
          stadt: 'Erfurt',
          standort: 'T.E.C.'
        });
      }
    };

    // Initiales Laden
    loadMarket();

    // Listener für Änderungen im localStorage (wenn in einem anderen Tab oder im Panel der Standardmarkt geändert wird)
    const handleStorageChange = (e) => {
      if (e.key === STORE_DATA_KEY) {
        loadMarket();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Custom Event Listener für Änderungen im selben Fenster (z.B. nach Save im Admin Panel)
    const handleCustomChange = () => {
      loadMarket();
    };
    window.addEventListener('tef_markets_updated', handleCustomChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('tef_markets_updated', handleCustomChange);
    };
  }, []);

  return (
    <MarketContext.Provider value={{ currentMarket }}>
      {children}
    </MarketContext.Provider>
  );
}

export function useMarket() {
  const context = useContext(MarketContext);
  if (context === undefined) {
    // Return a dummy object if used outside a provider to avoid breaking the app
    return { currentMarket: { kette: 'Media Markt', stadt: 'Erfurt', standort: 'T.E.C.' } };
  }
  return context;
}
